/* eslint-disable no-underscore-dangle */
import _ from 'underscore';
import { ViewItem, ViewItemTLString } from '@bingads-webui-campaign/reports-v4-component';
import { shouldShowSelector, shouldShowUserScopeInput } from '../helpers/account-selector-helper';
import { isInsertionOrderReport } from '../helpers/insertion-order-helper';

function toolbarItemsWithoutSelection({
  onDownload,
  reportSchema,
  scope,
  i18n,
  permissions,
  onViewItemChange,
  selectedViewItem = ViewItem.Monthly,
}) {
  let isSelectorShown = false;
  let isFilterShown = false;
  let isViewSelectorShown = false;
  let isInsertionOrderSelectorShown = false;
  if (reportSchema) {
    isSelectorShown = shouldShowSelector(reportSchema.ScopeFilterLevel, scope) || shouldShowUserScopeInput(reportSchema.ScopeFilterLevel);
    isFilterShown = reportSchema ? !_.isEmpty(reportSchema.Filters.properties) : false;
    isViewSelectorShown = isInsertionOrderReport({ reportType: reportSchema.ReportType, permissions });
    isInsertionOrderSelectorShown = isInsertionOrderReport({ reportType: reportSchema.ReportType, permissions });
  }

  const result = [
    ['predicate-list', {
      id: 'predicate-list',
      type: 'custom',
      _isValid: isFilterShown,
    }],
    ['conditional-format', {
      id: 'conditional-format',
      type: 'custom',
    }],
    ['expander', {
      type: 'expander',
    }],
    ['view-selector-toolbar-item', {
      id: 'view-selector-toolbar-item',
      type: 'dropdown',
      useFluentIcon: true,
      iconLeftGlyphName: 'ViewList',
      text: i18n.getString(ViewItemTLString[selectedViewItem]),
      shouldFocusOnContainer: true,
      menu: {
        items: [{
          text: i18n.getString(ViewItemTLString[ViewItem.Monthly]),
          id: 'monthly-view',
          onClick: () => { onViewItemChange(ViewItem.Monthly); },
        }, {
          text: i18n.getString(ViewItemTLString[ViewItem.Daily]),
          id: 'daily-view',
          onClick: () => { onViewItemChange(ViewItem.Daily); },
        }],
      },
      _isValid: isViewSelectorShown,
    }],
    ['insertion-order-selector-toolbar-item', {
      id: 'insertion-order-selector-toolbar-item',
      type: 'custom',
      _isValid: isInsertionOrderSelectorShown,
    }],
    // TODO(songgao): Not show account selector button in such cases
    // 1. when the category name is under "shopping"(This rule is not general, just try to imitate current behavior)
    ['account-selector-toolbar-item', {
      id: 'account-selector-toolbar-item',
      type: 'custom',
      _isValid: isSelectorShown,
    }],
    ['button-download', {
      id: 'button-download',
      type: 'dropdown',
      button: { text: i18n.getString(_TL_('Download')) },
      iconLeftGlyphName: 'ba-Download',
      menu: {
        items:
          [
            { text: _TL_('.zip (.csv)'), onClick: () => onDownload('Csvzip') },
            { text: _TL_('.zip (.tsv)'), onClick: () => onDownload('TsvZip') },
            { text: _TL_('.xlsx'), onClick: () => onDownload('Xlsx') },
          ],
      },
    }],
  ];

  return result.filter(([, value]) => value._isValid !== false);
}

export function getDefaultReportsGridToolbarConfig({
  onDownload, reportSchema, scope, i18n, permissions, onViewItemChange, selectedViewItem,
}) {
  return new Map(toolbarItemsWithoutSelection({
    onDownload, reportSchema, scope, i18n, permissions, onViewItemChange, selectedViewItem,
  }));
}
